/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export class ImageLoaderTypes {
    static DEFAULT = '';

    static POSTER_IMAGE = 'poster-image';

    static CHANNEL_BRANDING_IMAGE = 'channel-branding-image';

    static LEFT_ARROW_ICON = 'left-arrow-icon';

    static OPTION_BUTTON_ICON = 'option-button-icon';

    static OSD_BRANDING_ICON = 'osd-branding-icon';

    static OVERLAY_BRANDING_ICON = 'overlay-branding-icon';

    static SETTINGS_SCREEN_CHANNEL_BRANDING = 'settings-screen-channel-branding';

    static STANDARD_INFO_BANNER_PARTNER_BRANDING = 'standard-info-banner-partner-branding';

    static STANDARD_INFO_BANNER_PARTNER_BRANDING_WITH_SOCU_ICON =
        'standard-info-banner-partner-branding-with-socu-icon';

    static STANDARD_INFO_BANNER_CHANNEL_BRANDING = 'standard-info-banner-channel-branding';

    static PARTNER_IMAGE_PRIMARY_BRANDING = 'partner-image_primary_branding';

    static PROVIDER_IMAGE_PREVIEW_ICON = 'provider-image-preview-icon';

    static RIGHT_ARROW_ICON = 'right-arrow-icon';

    static SPLASH_SCREEN_PARTNER_BRANDING = 'splash-screen-partner-branding';

    static TEXT_VIEW_ICON = 'text-view-icon';

    static MEDIA_PAUSE_ICON = 'media-pause-icon';

    static MEDIA_HIGHLIGHTED_PAUSE_ICON = 'media-pause-icon highlighted';
}
